import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize, map } from 'rxjs';
import { HttpService } from 'src/app/core/services/api/http.service';

@Component({
  selector: 'app-new-notifications-popup',
  templateUrl: './new-notifications-popup.component.html',
  styleUrls: ['./new-notifications-popup.component.scss'],
})
export class NewNotificationsPopupComponent implements OnInit {
  notificationsNumber: number = 0;
  isLoading: boolean = false;

  constructor(
    private _api: HttpService,
    protected dialogRef: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.getAllUnreadMessages();
  }

  getAllUnreadMessages() {
    this.isLoading = true;
    this._api
      .getReq('/notifications?all=0')
      .pipe(
        map((res) => res?.data || []),
        finalize(() => (this.isLoading = false))
      )
      .subscribe((messages) => {
        this.notificationsNumber = messages.length;
      });
  }
}
